/* eslint-disable default-param-last */
import rdimsState from 'models/rdims';
import { RDIMS_ACTIONS } from 'actions/rdims';

const RdimsReducer = (state = rdimsState, action) => {
  switch (action.type) {
    case RDIMS_ACTIONS.SET_SELECTED_RDIMS:
      return {
        ...state,
        selectedRdims: action.payload.data,
        selectedIndex: action.payload.index
      };
    // case RDIMS_ACTIONS.TOGGLE_MY_LOCKS_FAX_id:
    //   return {
    //     ...state,
    //     isViewMyLocks: action.payload.btnState,
    //     selectedRowStatus: action.payload.status
    //   };
    case RDIMS_ACTIONS.TOGGLE_PACKET_LOCK_UNlOCK:
      return {
        ...state,
        selectedRdims: { ...state.selectedRdims, lockedBy: action.payload }
      };
    default:
      return state;
  }
};

export default RdimsReducer;
